/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { Cart } from './cart';
import { ReservationTimer } from './reservation_timer.jsx';
import * as Utilities from '../../utilities';
import { FormHeader } from '../../../react/form_header.jsx';
import { FormInputGroup } from '../../../react/form_input_group.jsx';
import { FormRow } from '../../../react/form_row.jsx';
import _ from 'underscore';
import React from 'react';
import immutable from 'object-path-immutable';
import PropTypes from 'prop-types';
import isemail from 'isemail';
import { AttendeeDetailForm } from './attendee_detail_form.jsx';

export class AttendeeDetails extends React.Component {
      constructor(props) {
        super(props);
        this.onSubmitForm = this.onSubmitForm.bind(this);
        this.onBack = this.onBack.bind(this);
this.onCancel = this.onCancel.bind(this);

        this.state =
          // Attendee details and survey responses
          {answers: props.attendees};
      }

      // Keep the answers in sync with the props, if they change
      UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.attendees !== this.props.attendees) {
          if (nextProps.attendees) { return this.setState({answers: nextProps.attendees}); }
        }
      }

      // Callback when an attendee's form is changed.
      //
      // ticket_class_id: ID of ticket class
      // attendee_number: Offset of attendee (i.e. "Default #2"), but zero based
      // name: Form field name
      // index: Form field index
      // value: New value
      onAttendeeChanged(ticket_class_id, attendee_number, name, index, value) {
        const update_path = [String(ticket_class_id), attendee_number - 1, name];
        if (index != null) { update_path.push(String(index)); }

        return this.setState({answers: immutable.set(this.state.answers, update_path, value)});
      }

      // Handle a form submission
      //
      // Calls the onSubmit callback with the form data provided by the user
      //
      // The answers are structured as a hash with the key being the ticket class id, and the value being
      // an array of responses for each attendee in that ticket class
      //
      // Each response is a hash of "name" or "email", and "answers", which is the response to questions by ID.
      onSubmitForm(event) {
        event.preventDefault();
        return (typeof this.props.onSubmit === 'function' ? this.props.onSubmit({attendees: this.state.answers}) : undefined);
      }

      // User requested navigation back to the quantity form
      onBack(event) {
        event.preventDefault();
        return (typeof this.props.onGoBack === 'function' ? this.props.onGoBack({attendees: this.state.answers}) : undefined);
      }

      // User requested to cancel checkout
      onCancel(event) {
        event.preventDefault();
        return (typeof this.props.onCancel === 'function' ? this.props.onCancel() : undefined);
      }

      renderAttendeeRows() {
        const my = this;
        return Array.from(this.props.cart.items).map((item) =>
          (() => {
            const result = [];
            for (var i = 1, end = item.quantity, asc = 1 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
              const answers = __guard__(my.state.answers != null ? my.state.answers[String(item.ticket_class_id)] : undefined, x => x[i - 1]) || __guard__(my.props.attendees != null ? my.props.attendees[item.ticket_class_id] : undefined, x1 => x1[i - 1]) || {};
              let errors = __guard__(my.props.attendee_errors != null ? my.props.attendee_errors[String(item.ticket_class_id)] : undefined, x2 => x2[i - 1]);

              // If there is a global need_attendees error, translate that into an error for this attendee
              if (my.props.attendee_errors === 'need_attendees') {
                errors = {
                  email: 'required',
                  name: 'required'
                };
              }

              result.push(<FormInputGroup className="attendee-group-wrap" key={`${item.ticket_class_id  }-${  i}`}>
                <legend className="em-attendee_section_title">{item.name} Attendee #{i}</legend>

                <AttendeeDetailForm item={item}
                                    index={i}
                                    questions={my.props.questions}
                                    answers={answers}
                                    errors={errors}
                                    attendee_sms_enabled={my.props.attendee_sms_enabled}
                                    key={`${item.ticket_class_id  }-${  i}`}
                                    onChange={my.onAttendeeChanged.bind(my, item.ticket_class_id, i)}
                />
              </FormInputGroup>);
            }
            return result;
          })());
      }

      render() {
        return <div className="widget-content">
          <ReservationTimer now={this.props.now}
                              reservationEnds={this.props.reservation_ends_at}
                              browserTimeOffset={this.props.browser_time_offset} />


            <form className="car_form form-sidebar">
              <span className="em-section_register_title">Attendee Information</span>
              {this.renderAttendeeRows()}

              <span className="em-section_register_title">Purchase Summary</span>
              <Cart items={this.props.cart.items}
                    showItemsOnly={true}
                    currency={this.props.currency} />


              {this.props.error && <p className="error_marker">There was an error processing your request. Please try again</p>}

              <div className="action_button">
                <a href="#" className="cancel_link em-link" onClick={this.onBack}>Back</a>
                <a href="#" className="cancel_link em-link" onClick={this.onCancel}>Cancel</a>
                <input type="submit"
                       className="em-button em-primary"
                       onClick={this.onSubmitForm}
                       disabled={this.props.loading}
                       value={this.props.loading ? "Processing..." : "Continue"} />

              </div>
            </form>
        </div>;
      }
}

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}